<template>
  <div class="container pt-9 mt-3 header-intro" v-if="content">
    <div class="row logos justify-content-between mx-1">
      <router-link :to="getRoute" class="image-logo w-100">
        <img class="w-100" src="@/assets/icons/logos/logo-sungevity-engie-white.svg" />
      </router-link>
    </div>
    <div class="row">
      <div class="col-12">
        <h2 v-if="headerText && !isB2b" class="font-weight-bold title text-white mt-5">{{ headerText }}</h2>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'HeaderBanner',
  computed: {
    ...mapGetters(['isAvailable', 'isGeneric', 'isOpenRedesign', 'fullName', 'loadingError']),
    getRoute: function () {
      if (this.$store.getters.iquote) {
        const { orderPlaced, paymentPending } = this.$store.getters.iquote

        if (this.isOpenRedesign) {
          return this.getContentProposalRoute
        }

        if (orderPlaced) return { name: 'Order' }
        if (!paymentPending) return this.getContentProposalRoute

        const paymentStatus = this.$store.getters.iquote.paymentStatus
        if (paymentStatus === 'PAID') {
          return { name: 'Order' }
        } else if (paymentStatus === 'OPEN') {
          return { name: 'OrderSummary' }
        }
        return this.getContentProposalRoute
      }
      return { name: '' }
    },
    getContentProposalRoute() {
      if (!this.multipleQuotes && this.$store.getters.iquote) {
        const quoteId = this.quotes[0].id
        return {
          name: 'card-detail',
          params: {
            id: quoteId,
          },
        }
      }
      return { name: 'ContentProposal' }
    },
    selectedQuote() {
      return this.quotes.findIndex((x) => x.id === this.$store.getters.quoteId) + 1 || ''
    },
    isB2b() {
      return !this.$route.path.startsWith('/iquote')
    },
    headerText() {
      try {
        const pc = this.$store.getters.content
        const { replaceDynamicContent } = this.$options.filters
        if (!Object.keys(pc).length) return ''
        switch (this.$route.name) {
          case 'iquoteNotFound':
            return pc.iquote_not_found_error_title
          case '500':
            return 'An error has occured. Please try again later'
          case '404':
            return pc.error_pagenotfound
          case 'iquoteNotAvailable':
            return pc.iquote_not_available_error_title
          case 'OrderSummary':
            return this.isGeneric
              ? replaceDynamicContent(pc.generic_summary_title, [this.selectedQuote])
              : pc.summary_title
          case 'Order':
            return replaceDynamicContent(pc.confirmation_title, [this.fullName])
          case 'OrderDetail':
            return pc.payment_detail_title
          case 'ContentProposal':
            if (this.isOpenRedesign) return pc.redesign_main_page_header
            if (this.loadingError) return 'An error has occured. Please try again later'
            if (!this.isAvailable) return pc.iquote_not_available_error_title
            return ''
          default:
            if (this.isOpenRedesign) return pc.redesign_main_page_header
            return replaceDynamicContent(pc[`pv_title_${this.quotes.length}`], [this.fullName])
        }
      } catch (error) {
        return ''
      }
    },
  },
}
</script>
